import { useParams, useSearchParams } from "react-router-dom";

export const useClipboardRoute = () => {
  const [searchParams] = useSearchParams();
  const {
    folderName,
    docId: routeDocumentId,
    searchId: routeSearchId,
    "*": wildcardFolderPath,
  } = useParams<{
    folderName?: string;
    docId?: string;
    searchId?: string;
    "*": string;
  }>();

  const path = routeSearchId
    ? ""
    : routeDocumentId
      ? searchParams.get("folder") || ""
      : wildcardFolderPath || folderName || "";
  const sharedOwnerId = searchParams.get("owner");
  const routeDocumentSubpath = routeDocumentId ? wildcardFolderPath || "" : "";

  return {
    path,
    sharedOwnerId,
    routeDocumentId,
    routeDocumentSubpath,
    routeSearchId,
  };
};
